Postlogin.Lesson = (function (my) {
    my.ImageScramble = function () {
        const me = Postlogin.Lesson.Segment.apply(this, arguments);
        me.play_pause_enabled = false;

        let imagePath = '';
        let size = 3;
        const containerId = `${me.activity_type}-container-${me.segment_index}`;
        let pieceSize;
        let container;
        let board;
        const pieces = [];
        const slots = [];
        let placed = 0;
        let isStarted = false;

        me.init = function () {
            if (me.activity_data.instructions) {
                me.help_enabled = true;
            }

            // the size is how many cells across/down
            // ex. a size of 3 leads to a 3x3 grid of 9 pieces
            size = me.options[Object.keys(me.options)[0]].answer;

            imagePath = me.options[Object.keys(me.options)[0]].answer_image;

            me.renderSegment();
        };

        me.renderSegment = function () {
            container = me.renderSegmentContainer();

            const imageScrambleContainer = $('<div></div>')
                .addClass(`${me.activity_type}-container segment-content-container`)
                .attr('id', containerId);
            board = $('<div></div>').addClass('board');

            // the percentage size of each piece
            pieceSize = 100 / size;

            createPieces();
            imageScrambleContainer.append(board);
            container.find('.aspect-wrapper').append(imageScrambleContainer);

            // add this segment container to the page
            $('#page-container').append(container);
        };

        /**
         * Create pieces and slots, and then randomly distribute pieces
         * */
        const createPieces = function () {
            // adjust the difficulty based on the grade level of the user.
            const gradeBand = Postlogin.Lesson.getGradeBand();
            let marginOfError = 4;
            switch (gradeBand) {
                case 'K-1':
                    marginOfError = 2;
                    break;
                case '2-3':
                    marginOfError = 3;
                    break;
                case '4-5':
                    marginOfError = 4;
                    break;
                default:
                    marginOfError = 4;
                    break;
            }

            const backgroundSize = 100 / (size - 1);
            for (let i = 0; i < size; i++) {
                pieces[i] = [];
                slots[i] = [];
                for (let j = 0; j < size; j++) {
                    const piece = $('<div></div>');

                    piece.css({
                        position: 'absolute',
                        width: `${pieceSize}%`,
                        height: `${pieceSize}%`,
                        left: `${pieceSize * i}%`,
                        top: `${pieceSize * j}%`,
                        'background-image': `url(${imagePath})`,
                        'background-size': `${size * 100}%`,
                        'background-position': `${backgroundSize * i}% ${backgroundSize * j}%`,
                    });

                    piece.attr('data-x', i);
                    piece.attr('data-y', j);

                    const slot = piece.clone(false);

                    piece.addClass('piece').addClass('unmoved');
                    piece.attr('id', `${containerId}__piece-${i}-${j}`);
                    piece.draggable({
                        snap: '.slot',
                        cursor: 'grabbing',
                        containment: `#${containerId}`,
                        scroll: false,
                        // eslint-disable-next-line no-loop-func
                        stop(event, ui) {
                            const pieceDraggable = $(this);

                            // get board position (top, left)
                            const boardDraggable = $(container).find('.board');
                            const boardPosition = $(boardDraggable).offset();
                            const boardWidth = $(boardDraggable).width();
                            const boardHeight = $(boardDraggable).height();

                            const boardLeft = boardPosition.left;
                            const boardRight = boardLeft + boardWidth;
                            const boardTop = boardPosition.top;
                            const boardBottom = boardTop + boardHeight;

                            const pieceWidth = $(pieceDraggable).width();
                            const pieceHeight = $(pieceDraggable).height();
                            const pieceTop = ui.offset.top;
                            const pieceLeft = ui.offset.left;
                            const pieceBottom = pieceTop + pieceHeight;
                            const pieceRight = pieceLeft + pieceWidth;

                            const piecePositionTop = Math.round(ui.position.top);
                            const piecePositionLeft = Math.round(ui.position.left);

                            // is the piece touching the board?
                            if (pieceRight > boardLeft && pieceLeft < boardRight && pieceTop < boardBottom && pieceBottom > boardTop) {
                                let overSlot = false;
                                // see if piece is directly above a slot
                                $(container)
                                    .find('.slot')
                                    .each(function () {
                                        const position = $(this).position();
                                        const slotTop = Math.round(position.top);
                                        const slotLeft = Math.round(position.left);
                                        if (
                                            Math.abs(piecePositionTop - slotTop) <= pieceHeight / marginOfError
                                            && Math.abs(piecePositionLeft - slotLeft) <= pieceWidth / marginOfError
                                        ) {
                                            overSlot = $(this);
                                            return false;
                                        }
                                    });

                                const x = $(pieceDraggable).attr('data-x');
                                const y = $(pieceDraggable).attr('data-y');

                                if (
                                    overSlot !== false
                                    && $(overSlot).attr('data-x') === $(pieceDraggable).attr('data-x')
                                    && $(overSlot).attr('data-y') === $(pieceDraggable).attr('data-y')
                                ) {
                                    me.placePiece(x, y);
                                } else {
                                    Postlogin.Lesson.playSoundEffect('incorrect');
                                    $(event.target).removeClass('animated tada shake incorrect').addClass('animated shake incorrect');
                                    setTimeout(() => {
                                        $(event.target).removeClass('animated tada shake incorrect');
                                    }, 1000);
                                }
                            }
                        },
                    });

                    piece.mousedown(() => {
                        Postlogin.Lesson.playSoundEffect('pick_up');
                    });

                    slot.addClass('slot');
                    slot.attr('id', `${containerId}__slot-${i}-${j}`);
                    slot.droppable({ accept: `#${containerId} #${containerId}__piece-${i}-${j}` });

                    pieces[i][j] = piece;
                    slots[i][j] = slot;
                    board.append(slot);
                    board.append(piece);
                } // end for y
            } // end for x
        };

        /**
         *  Randomly distributes a piece to the left or right of the baord
         * */
        const randomizePiece = function (piece) {
            setTimeout(() => {
                // left or right side?
                const side = Math.round(Math.random());
                const yMin = 0;
                const yMax = 100 - pieceSize;
                let xMin;
                let xMax;

                // if we're sending this piece to the left...
                if (side === 0) {
                    xMin = -pieceSize;
                    xMax = -50;
                } else {
                    // if we're sending this piece to the right...
                    xMin = 100;
                    xMax = 150 - pieceSize;
                }

                // play a swooshing sound as the piece moves
                // with a random volume
                Postlogin.Lesson.playSoundEffect('swoosh', Math.floor(Math.random() * (10 - 1 + 1) + 1) / 10);

                // remove the class that is hiding the box-shadow on the piece
                piece.removeClass('unmoved');
                piece.addClass('animated tada');
                // move the piece to a random position, and take between 2 and 3 seconds.
                piece.animate(
                    {
                        left: `${Math.floor(Math.random() * (xMax - xMin + 1) + xMin)}%`,
                        top: `${Math.floor(Math.random() * (yMax - yMin + 1) + yMin)}%`,
                    },
                    Math.floor(Math.random() * (2000 - 500 + 1) + 500),
                    'easeInOutQuint',

                    () => {
                        piece.removeClass('animated jello');
                    },
                );
            }, Math.floor(Math.random() * (2000 - 500 + 1) + 500));
        };

        me.placePiece = function (x, y) {
            const piece = $(`#${containerId} #${containerId}__piece-${x}-${y}`);
            $(piece).remove();
            $(`#${containerId} #${containerId}__slot-${x}-${y}`)
                .addClass('filled')
                .addClass('glow')
                .animate(
                    {
                        opacity: 1,
                        outline: 0,
                        border: 0,
                    },
                    400,
                    () => {
                        $(`#${containerId} #${containerId}__slot-${x}-${y}`).removeClass('glow');
                    },
                );
            placed++;

            Postlogin.Lesson.playSoundEffect('click');
            Postlogin.Lesson.playSoundEffect('glow');

            if (placed === size * size) {
                board.addClass('glow');

                setTimeout(() => {
                    Postlogin.Lesson.Popup.showCompletionModal(me);
                }, 250);
            }
        };

        // TODO: take a random piece, move it to correct place
        me.solveOne = function () {
            const pieceX = Math.floor(Math.random() * size);
            const pieceY = Math.floor(Math.random() * size);

            if (pieces[pieceX][pieceY].hasClass('ui-draggable')) {
                me.placePiece(pieceX, pieceY);
            } else if (placed < size * size) {
                me.solveOne();
            }
        };

        // TODO: move all pieces to correct place
        me.solve = function () {
            for (let i = 0; i < size * size; i++) {
                setTimeout(() => {
                    me.solveOne();
                }, 500 * i);
            }
        };

        /**
         *  Randomly distributes all pieces to the left or right of the baord
         * */
        me.begin = function () {
            $(`#${containerId} .piece`).each((i, piece) => {
                randomizePiece($(piece));
            });
            isStarted = true;
        };

        me.mute = function () {
            Postlogin.Lesson.stopAllSounds();
        };

        me.replay = function (forceShowHelp = false) {
            Postlogin.Lesson.hideNextButton();
            $(container).find('.piece').remove();
            $(container).find('.slot').remove();
            board.removeClass('glow');
            placed = 0;
            createPieces();
            Postlogin.Lesson.Popup.showHelp(
                me,
                () => {
                    me.begin();
                },
                forceShowHelp,
            );
        };

        me.show = function () {
            me.setup();

            Postlogin.Lesson.Popup.showHelp(me, () => {
                if (!isStarted) {
                    me.begin();
                }

                if (me.completed && !me.last) {
                    Postlogin.Lesson.showNextButton();
                }
            });
        };

        me.hide = function () {
            me.breakdown();
        };

        me.getSize = function () {
            return size;
        };

        return me;
    };

    return my;
}(Postlogin.Lesson || {}));
